import { render, staticRenderFns } from "./EditQuestionary.vue?vue&type=template&id=615b049c&"
import script from "./EditQuestionary.vue?vue&type=script&lang=js&"
export * from "./EditQuestionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports